'use client'

import styled from '@emotion/styled'
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useRouter } from 'next/navigation'
import React, { useCallback } from 'react'
import { useLocale } from '../../../hooks/useLocale'
import { colors } from '../../../styles/theme'

type Props = {
  backUrl?: string
}

export const HeaderWithBack: React.FC<Props> = ({ backUrl }) => {
  const { t } = useLocale()
  const router = useRouter()
  const onClickBack = useCallback(() => {
    if (backUrl) {
      router.push(backUrl)
    } else {
      router.back()
    }
  }, [backUrl, router])
  return (
    <NavBack>
      <BackButton onClick={onClickBack}>
        <BackButtonIcon>
          <FontAwesomeIcon icon={faAngleLeft} size="1x" />
        </BackButtonIcon>
        <BackButtonLabel>{t.戻る}</BackButtonLabel>
      </BackButton>
    </NavBack>
  )
}

const NavBack = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
  border-bottom: solid 1px #e5e5e5;
  height: 48px;
  display: flex;
  align-items: center;
  z-index: 100;
`

const BackButtonIcon = styled.div`
  width: 12px;
  margin-right: 8px;
  color: ${colors.text.primary};
  margin-top: 2px;
`

const BackButton = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
  margin-left: 16px;
`

const BackButtonLabel = styled.div`
  font-size: 16px;
  color: ${colors.text.primary};
`
